import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { Track } from "store/track/track.model";

interface ArchiveState {
  tracks: Track[];
}

const initialState: ArchiveState = { tracks: [] };

export const archiveSlice = createSlice({
  name: "archive",
  initialState,
  reducers: {
    addTrack: (state, action: PayloadAction<{ track: Track }>) => {
      state.tracks.push(action.payload.track);
    },
    removeTrack: (state, action: PayloadAction<{ trackId: string }>) => {
      state.tracks.splice(
        state.tracks.findIndex((track) => track.id === action.payload.trackId),
        1
      );
    },
    setTrackDownloadProgress: (
      state,
      action: PayloadAction<{ trackId: string; downloadProgress: number }>
    ) => {
      const track = state.tracks.find(
        (track) => track.id === action.payload.trackId
      );
      if (track) {
        track.downloadProgress = action.payload.downloadProgress;
      }
    },
    setTrackStreamLink: (
      state,
      action: PayloadAction<{ trackId: string; streamLink: string }>
    ) => {
      const track = state.tracks.find(
        (track) => track.id === action.payload.trackId
      );
      if (track) {
        track.streamLink = action.payload.streamLink;
      }
    },
  },
});

export const { reducer: archiveReducer, actions: archiveActions } =
  archiveSlice;
